import { Container, Grid, Paper } from '@material-ui/core'
import { components, useTranslation } from 'cng-web-lib'
import React from 'react'

import { useParams } from 'react-router-dom'
import CommonConfigKeys from 'src/constants/locale/key/CommonConfig'
import Namespace from 'src/constants/locale/Namespace'
import CommonConfigViewForm from './CommonConfigViewForm'

const { CngTabs } = components


function ViewPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.COMMON_CONFIG])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let batchDataConfig = translate(
      Namespace.COMMON_CONFIG,
      CommonConfigKeys.TITLE
    )

    return {
      batchDataConfig
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CommonConfigViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
                //do nothing
              }}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.batchDataConfig,
              tabContent: (
                <CommonConfigViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage